import editUserProfilePersonalityDialog from './edit-user-profile-personality-dialog.json';
import editUserProfilePersonalityInvestmentExperience from './edit-user-profile-personality-investment-experience.json';

export default {
  'edit-user-profile-personality': {
    'main-dialog': editUserProfilePersonalityDialog,
    'investment-experience': editUserProfilePersonalityInvestmentExperience,
  },
};
